import { openEnquiry, scrollTo } from "../../lib/api";
import { Reveal } from "../Reveal";
import { LeadForm } from "./LeadForm";

const PILLS = ["Personal", "Business", "Home", "Vehicle", "Since 2017"];
const TRUST = [["10,000+", "enquiries"], ["20+", "lending partners"], ["4.8★", "rating"]];

function TrustStrip() {
  return (
    <div className="max-w-[1200px] mx-auto px-4 md:px-8 pb-12">
      <div data-testid="trust-strip" className="rounded-[24px] bg-[#f4f5f6] border border-[#e1e2e5] px-6 py-5 grid grid-cols-3 divide-x divide-[#e1e2e5]">
        {TRUST.map(([n, l]) => (
          <div key={l} className="text-center px-2" data-testid={`trust-${l.replace(/\s+/g, "-")}`}>
            <div className="text-2xl md:text-3xl font-extrabold tracking-[-0.03em] text-[#191c1f]">{n}</div>
            <div className="mt-1 text-xs md:text-sm font-bold text-[#6b6f76]">{l}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

export function Hero({ settings }) {
  return (
    <section id="top" className="relative overflow-hidden">
      <div className="max-w-[1200px] mx-auto px-4 md:px-8 pt-10 md:pt-16 pb-12 grid lg:grid-cols-2 gap-10 items-center">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.2em] font-extrabold text-[#f06400]">
            Bharosa Bhi, Loan Bhi
          </p>
          <h1 className="mt-3 text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-[-0.035em] leading-[1.02]">
            Loans, made<br />simple.
          </h1>
          <p className="mt-5 text-base md:text-lg text-[#191c1f]/75 max-w-xl leading-relaxed">
            Compare options, check eligibility in a minute and apply through our lending partners.
          </p>
          <div className="mt-6 flex flex-wrap gap-3">
            <button data-testid="hero-check-options-btn" onClick={() => openEnquiry({})}
              className="min-h-[48px] px-7 rounded-full bg-[#191c1f] hover:bg-black text-white font-bold transition active:scale-95">
              Check my options
            </button>
            <button data-testid="hero-plan-emi-btn" onClick={() => scrollTo("tools")}
              className="min-h-[48px] px-7 rounded-full border-2 border-[#191c1f] font-bold hover:bg-[#f4f5f6] transition active:scale-95">
              Plan my EMI
            </button>
          </div>
          <div className="mt-6 flex flex-wrap gap-2">
            {PILLS.map((p) => (
              <span key={p} className="text-xs font-bold px-3 py-1.5 rounded-full bg-[#f4f5f6] border border-[#e1e2e5]">
                {p}
              </span>
            ))}
          </div>
          <p className="mt-6 text-sm text-[#6b6f76] max-w-xl">
            We are a loan facilitation platform, not a lender.{" "}
            <button onClick={() => scrollTo("licences")} className="font-bold text-[#004040] underline" data-testid="hero-licences-link">
              Disclosures
            </button>
          </p>
        </Reveal>

        <Reveal delay={120} className="justify-self-center">
          <div data-testid="hero-phone-lead-form"
            className="relative mx-auto border-[10px] sm:border-[12px] border-[#191c1f] rounded-[40px] sm:rounded-[44px] shadow-2xl bg-white w-[360px] max-w-full">
            <div className="absolute top-2 left-1/2 -translate-x-1/2 h-5 w-28 bg-[#191c1f] rounded-b-2xl z-10" />
            <div className="p-5 pt-8 max-h-[640px] overflow-y-auto no-scrollbar">
              <p className="text-xs uppercase tracking-widest font-extrabold text-[#f06400] mb-1">Free check</p>
              <h2 className="text-xl font-extrabold tracking-[-0.03em] mb-3">Check eligibility</h2>
              {settings && <LeadForm settings={settings} variant="phone" />}
            </div>
          </div>
        </Reveal>
      </div>
      <Reveal delay={200}><TrustStrip /></Reveal>
      <div className="hidden md:block absolute -top-20 right-0 w-[320px] h-[320px] rounded-full bg-[#fff0e6] blur-3xl -z-10 opacity-70" />
      <div className="hidden md:block absolute -bottom-32 left-0 w-[320px] h-[320px] rounded-full bg-[#e2f0ef] blur-3xl -z-10 opacity-70" />
    </section>
  );
}
